export enum EPaymentMethod {
    DEPOSIT_ACCOUNT = 'deposit-account',
    BANK_TRANSFER = 'bank-transfer',
}